/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useEffect, useState } from 'react';

import PopupLayout from '../pages/main/PopupLayout';
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import { useLazyQuery, useMutation } from '@apollo/client';
import { getOperationItems } from '../graphql';
import { useProducts, useTemplate, useWindowDimensions } from '../hooks';
import { TextFieldLocal } from '../components';
import { LinkLocation, LinkPhone, timeToHourMinute } from '../common';
import Whatsapp from '../common/Whatsapp';
import createInvoiceEventEmployee from '../graphql/mutation/createInvoiceEventEmployee';

export const indexTheList = (list: any) => {
  return list.map((item: any, index: any) => {
    return {
      ...item,
      index,
    };
  });
};

const PopupEmployeeEdit = ({
  open,
  onClose,
  row,
  editAction,
  servicesproducts,
  theme,
  isRTL,
}: any) => {
  const {
    customerName,
    customerNameAr,
    customerPhone,
    amount,
    docNo,
    title,
    locationLink,
    address,
    houseno,
    desc,
  } = row;
  const startDate = new Date(row?.startDate);
  const endDate = new Date(row?.endDate);
  const [paid, setPaid] = useState(row?.cashin);
  const [statusaction, setStatusaction] = useState(row.status);
  const [note, setNote] = useState(row?.note);

  const [itemsList, setItemsList] = useState<any>([]);
  const { products } = useProducts();
  const { isMobile } = useWindowDimensions();
  const { eventoptions } = useTemplate();

  const [getItems, itemsData]: any = useLazyQuery(getOperationItems, {
    fetchPolicy: 'cache-and-network',
  });
  const [addInvoice] = useMutation(createInvoiceEventEmployee);

  useEffect(() => {
    if (row && row._id) {
      const items = itemsData?.data?.['getOperationItems']?.data || [];

      if (items && items.length > 0) {
        const ids = items.map((it: any) => it.itemId);
        const servlist = [...servicesproducts, ...products].filter((ser: any) =>
          ids.includes(ser._id)
        );
        const itemsWqtyprice = items.map((item: any, index: any) => {
          const {
            categoryId,
            categoryName,
            categoryNameAr,
            departmentId,
            departmentName,
            departmentNameAr,
            departmentColor,
            employeeId,
            employeeName,
            employeeNameAr,
            employeeColor,
            resourseId,
            resourseName,
            resourseNameAr,
            resourseColor,
            contractId,
            contractName,
            contractNameAr,
            projectId,
            projectName,
            projectNameAr,
            note,
          } = item;
          const serv = servlist.filter((se: any) => se._id === item.itemId)[0];
          return {
            ...serv,
            categoryId,
            categoryName,
            categoryNameAr,
            departmentId,
            departmentName,
            departmentNameAr,
            departmentColor,
            employeeId,
            employeeName,
            employeeNameAr,
            employeeColor,
            resourseId,
            resourseName,
            resourseNameAr,
            resourseColor,
            contractId,
            contractName,
            contractNameAr,
            projectId,
            projectName,
            projectNameAr,
            index,
            itemprice: item.itemPrice,
            itemqty: item.qty,
            itemtotal: item.total,
            note,
            // itemtotalcost: item.qty * serv.cost,
          };
        });
        itemsWqtyprice.sort((a: any, b: any) =>
          a.indx > b.indx ? 1 : b.indx > a.indx ? -1 : 0
        );
        setItemsList(itemsWqtyprice);
      }
    }
  }, [itemsData, row]);
  useEffect(() => {
    if (row && row?._id) {
      getItems({ variables: { opId: row?._id } });
    }
  }, [row]);

  const options: any = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  return (
    <PopupLayout
      isRTL={isRTL}
      open={open}
      onClose={onClose}
      title={row?.title}
      onSubmit={() => null}
      theme={theme}
      onlyclose={true}
      mt={10}
      mb={20}
      canceltitle={isRTL ? 'اغلاق' : 'Close'}
      preventclose
      maxWidth="lg"
    >
      <Grid container spacing={0}>
        <Grid item xs={12} md={12}>
          <Grid container spacing={1}>
            <Grid item md={6} xs={12}>
              <FormControl
                style={{ minWidth: 150, marginTop: isMobile ? undefined : 8 }}
              >
                <InputLabel id="select-label">
                  {isRTL ? 'الحالة' : 'Status'}
                </InputLabel>
                <Select
                  labelId="select-label"
                  id="select"
                  variant="outlined"
                  value={statusaction ? statusaction : row.status}
                  onChange={(e: any) => {
                    setStatusaction(e.target.value);
                  }}
                >
                  <MenuItem value={2}>{isRTL ? 'مؤكد' : 'Confirmed'}</MenuItem>
                  {/* <MenuItem value={4}>{isRTL ? 'ملغى' : 'Canceled'}</MenuItem> */}
                  <MenuItem value={6}>
                    {isRTL ? 'قيد الانجاز' : 'In Progress'}
                  </MenuItem>
                  <MenuItem value={10}>{isRTL ? 'منجز' : 'Completed'}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={6} xs={12}>
              <Box
                style={{
                  display: 'flex',
                  marginTop: isMobile ? -10 : undefined,
                }}
              >
                <TextFieldLocal
                  name="price"
                  label={isRTL ? 'نقداً' : 'Cash'}
                  value={paid}
                  onChange={(e: any) => setPaid(Number(e.target.value))}
                  type="number"
                  width={150}
                  mb={0}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                style={{
                  display: 'flex',
                  marginTop: -8,
                }}
              >
                <TextFieldLocal
                  name="note"
                  label={isRTL ? 'ملاحظة' : 'Note'}
                  value={note}
                  onChange={(e: any) => setNote(e.target.value)}
                  fullWidth
                  mb={0}
                />
              </Box>
            </Grid>
            <Grid item md={6} xs={12}>
              <Button
                variant="contained"
                color="primary"
                style={{
                  height: 36,
                  width: 150,
                }}
                onClick={() => {
                  editAction({
                    variables: {
                      id: row.id,
                      cashin: paid,
                      status: statusaction ? statusaction : undefined,
                      note,
                    },
                    optimisticResponse: {
                      __typename: 'updateEvent',
                      updateEvent: {
                        __typename: 'Operation',
                        ...row,
                        id: row.id,
                        cashin: paid,
                        status: statusaction,
                        note,
                      },
                    },
                  });
                  if (statusaction === 10) {
                    addInvoice({
                      variables: {
                        eventId: row?._id,
                        cashin: paid,
                      },
                    });
                  }
                  onClose();
                }}
              >
                <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                  {isRTL ? 'حفظ' : 'Save'}
                </Typography>
              </Button>
            </Grid>
            <Grid item md={6} xs={12}>
              {locationLink && (
                <LinkLocation isRTL={isRTL} value={locationLink}></LinkLocation>
              )}
              <Typography>{houseno}</Typography>
            </Grid>
          </Grid>
          <Divider style={{ marginTop: 10, marginBottom: 10 }}></Divider>
          <Box
            display="flex"
            style={{ alignItems: 'center', justifyContent: 'flex-end' }}
          >
            <Typography style={{ fontWeight: 'bold' }} variant="body2">
              {docNo}
            </Typography>
          </Box>
          {eventoptions?.title && (
            <Box style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
              <Typography style={{ fontWeight: 'bold' }} variant="body2">
                {title}
              </Typography>
            </Box>
          )}
          <Box
            display="flex"
            style={{ alignItems: 'center', justifyContent: 'space-between' }}
          >
            <Box>
              <Typography gutterBottom variant="subtitle2" component="h2">
                {startDate.toLocaleString(isRTL ? 'ar-QA' : 'en-US', options)}
              </Typography>
            </Box>
            <Box display="flex" style={{ marginBottom: 3 }}>
              <div>
                {timeToHourMinute(startDate, isRTL ? 'ar-QA' : 'en-US')} -{' '}
              </div>
              <div> {timeToHourMinute(endDate, isRTL ? 'ar-QA' : 'en-US')}</div>
            </Box>
          </Box>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography gutterBottom variant="h5">
              {isRTL ? customerNameAr : customerName}
            </Typography>
            {customerPhone && customerPhone?.length > 0 && (
              <Box display={'flex'}>
                <Whatsapp phone={customerPhone}></Whatsapp>
                <LinkPhone value={customerPhone}></LinkPhone>
              </Box>
            )}
          </Box>
          <Divider style={{ marginTop: 10, marginBottom: 10 }}></Divider>
          <Box
            display="flex"
            style={{ alignItems: 'center', justifyContent: 'space-between' }}
          >
            <Grid container spacing={1}>
              {itemsList?.map((item: any) => {
                const name = isRTL
                  ? item?.nameAr?.substring(0, 40)
                  : item?.name?.substring(0, 40);
                const employee = isRTL
                  ? item?.employeeNameAr
                  : item?.employeeName;
                return (
                  <>
                    <Grid item xs={5}>
                      <Typography>{name}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography>{employee}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography>{item?.itemqty}</Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography>{item?.itemprice}</Typography>
                    </Grid>
                  </>
                );
              })}
              <Grid item xs={8}></Grid>
              <Grid item xs={4}>
                <Box
                  display={'flex'}
                  justifyContent="center"
                  alignItems={'center'}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#667fb5',
                  }}
                >
                  <Typography
                    style={{
                      marginTop: 3,
                      color: '#fff',
                    }}
                    gutterBottom
                    variant="subtitle2"
                    component="h2"
                  >
                    {amount} QR
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box
            display="flex"
            style={{
              flexWrap: 'wrap',
              wordWrap: 'break-word',
              whiteSpace: 'normal',
            }}
          >
            <Typography>{desc}</Typography>
            <Typography style={{ marginTop: 10 }}>{address}</Typography>
          </Box>
        </Grid>
      </Grid>
    </PopupLayout>
  );
};

export default PopupEmployeeEdit;
